module.exports = __webpack_public_path__ + "img/Slide21.121e6264.png";